'use strict';

var updateDate = require('./updateDate'),
    collectDateArguments = require('./collectDateArguments');

function advanceDateWithArgs(d, args, dir) {
  args = collectDateArguments(args, true);
  return updateDate(d, args[0], args[1], dir);
}

module.exports = advanceDateWithArgs;


//////////////////
// WEBPACK FOOTER
// ./node_modules/sugar-date/date/internal/advanceDateWithArgs.js
// module id = 91
// module chunks = 1